import { Component, EventEmitter, Input, Output} from '@angular/core';

import { CriticalMessageModel } from './typings/critical-message';

@Component({
  template: require('./critical-messages.actions.component.html')
})
export class CriticalMessagesActionsComponent {
  @Input() record: CriticalMessageModel;

  @Output() onVerifyClick : EventEmitter<any> = new EventEmitter();

  isUnverified () : boolean {
    return this.record.status
      && this.record.status === 'unverified';
  }
}
